import React from 'react'
import { useTranslation } from 'hooks/useTranslation'
import {
  HowItWorksRoot,
  HeaderBox,
  Header,
  HowItWorksBox,
  TextColumn,
  PointsList,
  PointsListItem,
  CheckIcon,
  ImageColumn,
  ImageWrapper,
} from './HowItWorks.styles'
import Image from 'next/image'
import freezeDriedChickenHalf from '../../../../../../public/assets/recipes/freezeDried/freeze-dried-half-bowl-chicken.webp'
import { Text } from 'components/Text'
import Trans from 'next-translate/Trans'
export const HowItWorks = () => {
  const { t } = useTranslation()

  return (
    <HowItWorksRoot>
      <HeaderBox>
        <Header>{t('recipes-overview:how-it-works.freeze-dried.title')}</Header>
      </HeaderBox>
      <HowItWorksBox>
        <ImageColumn>
          <ImageWrapper>
            <Image
              layout="fill"
              objectFit="cover"
              src={freezeDriedChickenHalf}
              alt={t('recipes-overview:how-it-works.freeze-dried.image-alt')}
            />
          </ImageWrapper>
        </ImageColumn>
        <TextColumn>
          <PointsList>
            <PointsListItem>
              <CheckIcon name="check" />
              <Text size="body">
                <Trans
                  i18nKey={t(`recipes-overview:how-it-works.freeze-dried.points.1`)}
                  components={{
                    strong: <strong />,
                  }}
                />
              </Text>
            </PointsListItem>
            <PointsListItem>
              <CheckIcon name="check" />
              <Text size="body">
                <Trans
                  i18nKey={t(`recipes-overview:how-it-works.freeze-dried.points.2`)}
                  components={{
                    strong: <strong />,
                  }}
                />
              </Text>
            </PointsListItem>
            <PointsListItem>
              <CheckIcon name="check" />
              <Text size="body">
                <Trans
                  i18nKey={t(`recipes-overview:how-it-works.freeze-dried.points.3`)}
                  components={{
                    strong: <strong />,
                  }}
                />
              </Text>
            </PointsListItem>
          </PointsList>
        </TextColumn>
      </HowItWorksBox>
    </HowItWorksRoot>
  )
}

HowItWorks.displayName = 'HowItWorks'
